import React, { useEffect } from "react";

const sections = [
  {
    title: "1. Information We Collect",
    paragraphs: [
      "Vionix Tracker collects information needed to provide live tracking, race progress monitoring, and activity recording. This may include account information, device information, event identifiers, timestamps, and precise location data.",
      "Location data may be collected while the app is open and, when permission is granted, while the app is running in the background. Background location is required so tracking can continue when the screen is locked or the app is not actively visible.",
    ],
  },
  {
    title: "2. How We Use Information",
    paragraphs: [
      "We use collected information to show participant locations, record activity history, calculate distance and movement statistics, support event operations, improve reliability, and troubleshoot technical issues.",
      "We do not sell personal data to third parties for advertising purposes.",
    ],
  },
  {
    title: "3. Third-Party Services",
    paragraphs: [
      "Vionix Tracker uses third-party services such as Google Maps SDK and Firebase to provide maps, authentication, storage, and server infrastructure.",
      "These providers process data only as needed to support app functionality and service delivery.",
    ],
  },
  {
    title: "4. Location Permissions",
    paragraphs: [
      "Users can manage or revoke location permissions at any time through device settings.",
      "Disabling background location may prevent the app from tracking activity when the screen is off or when the app is in the background.",
    ],
  },
  {
    title: "5. Data Security",
    paragraphs: [
      "We use reasonable technical and organizational measures to protect information from unauthorized access, loss, misuse, or alteration.",
      "No digital service can guarantee absolute security, but we work to keep our systems reliable and protected.",
    ],
  },
  {
    title: "6. Contact",
    paragraphs: [
      "For questions about this Privacy Policy or requests related to your data, contact us at contact@vionixasia.com.",
    ],
  },
];

export const PrivacyPolicyTracker = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-white text-slate-900">
      <div className="mx-auto max-w-3xl px-4 py-16 md:py-24">
        <header className="mb-12 border-b border-slate-200 pb-8">
          <h1 className="text-3xl md:text-5xl font-black tracking-tighter uppercase">
            Privacy Policy
          </h1>
          <p className="mt-4 text-sm font-semibold text-slate-500">
            Last updated: May 15, 2026
          </p>
        </header>

        <section className="mb-10">
          <p className="text-base md:text-lg leading-8 text-slate-600">
            Vionix Tracker is committed to protecting user privacy. This Privacy Policy explains how we collect, use, and protect information when users access the Vionix Tracker mobile application and related live tracking services.
          </p>
        </section>

        <div className="space-y-10">
          {sections.map((section) => (
            <section key={section.title}>
              <h2 className="mb-4 text-xl md:text-2xl font-bold tracking-tight text-slate-900">
                {section.title}
              </h2>
              <div className="space-y-4">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph} className="text-base leading-8 text-slate-600">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
};
